import script from "./CustomChip.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomChip.vue?vue&type=script&setup=true&lang=js"

import "./CustomChip.vue?vue&type=style&index=0&id=b946994e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b946994e"]])

export default __exports__